export const REFERRER_FRIEND_CODE_QUERY_PARAM = 'r';
export const REFERRER_EXTERNAL_CODE_QUERY_PARAM = 'utm_source';

export const REFERRER_CODE_KEY = 'referrer';
export const REFERRER_NEXT_CODE_KEY = 'referrerNext';
export const REFERRER_FRIEND_CODE_KEY = 'referrerFriendCode';
